export default function getTicketCountsBasedOnType(ticketType, numAdults, numChildren) {
	let adults, children;
	switch (ticketType.type) {
		case 'UNI':
			adults = numAdults;
			children = numChildren;
			break;
		case 'ADT':
			adults = ticketType.ticketCount;
			break;
		case 'CHD':
			children = ticketType.ticketCount;
			break;
		case 'GRP':
			adults = ticketType.groupNumAdults;
			children = ticketType.groupNumChildren;
			break;
		case 'AAT':
			adults = ticketType.ticketCount;
			break;
		case 'ACD':
			children = ticketType.ticketCount;
			break;
		default:
			adults = undefined;
			children = undefined;
	}
	return { adults, children };
}
